<!-- <ng-container [formArrayName]="'Payments'">
    <ng-container [formGroupName]="'0'">
        
    </ng-container>
</ng-container> -->
<z-select
    id="{{ id() }}"
    [options]="options()"
    [style]="inputStyle()"
    [optionLabel]="optionLabel()"
    [optionValue]="optionValue()"
    [placeholder]="placeholder()"
    [label]="label()"
    [class]="class"
    [filter]="false"
    [showClear]="false"
    [readonly]="
        rootFormGroup?.form?.controls?.['CompletionDateTime']?.value !=
        undefined
    "
    formControlName="ProvidedServiceCategory"
    (ngModelChange)="onModelChange($event)"
/>
